import { useEffect, useRef, useState } from 'react';
import './RailwayTrack.css';

export default function RailwayTrack({ items, renderItem }) {
  const trackRef = useRef(null);
  const itemRefs = useRef([]);
  const [progress, setProgress] = useState(0);
  const [activeCount, setActiveCount] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const track = trackRef.current;
      if (!track) return;

      const rect = track.getBoundingClientRect();
      const viewportMid = window.innerHeight * 0.72;
      const total = rect.height;
      const traveled = Math.min(Math.max(viewportMid - rect.top, 0), total);
      setProgress(total > 0 ? (traveled / total) * 100 : 0);

      let count = 0;
      itemRefs.current.forEach((node) => {
        if (!node) return;
        const nodeRect = node.getBoundingClientRect();
        if (nodeRect.top < viewportMid) count += 1;
      });
      setActiveCount(count);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [items.length]);

  return (
    <div className="railway" ref={trackRef}>
      <div className="railway-line">
        <div className="railway-line-fill" style={{ height: `${progress}%` }} />
      </div>

      <div className="railway-stops">
        {items.map((item, i) => (
          <div
            key={item.key ?? i}
            ref={(node) => { itemRefs.current[i] = node; }}
            className={`railway-stop ${i < activeCount ? 'is-active' : ''}`}
          >
            <span className="railway-dot" />
            <div className="railway-content">{renderItem(item, i)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
